import { StandardEvents } from '@shopify/events';

const BADGE_POP_MS = 520;
const CART_BUMP_MS = 480;

/** @returns {HTMLElement | null} */
function getCartIconWrap() {
  return document.querySelector('.uucck-mobile-tab-bar__item--cart .uucck-mobile-tab-bar__icon--cart');
}

/**
 * @param {number} itemCount
 * @param {{ animate?: boolean }} [options]
 */
function renderMobileCartBadge(itemCount, options = {}) {
  const { animate = true } = options;
  const icon = getCartIconWrap();
  if (!icon) return;

  /** @type {HTMLElement | null} */
  let badge = icon.querySelector('.uucck-mobile-tab-bar__badge');
  const prev = badge ? parseInt(badge.textContent || '0', 10) : 0;

  if (itemCount <= 0) {
    badge?.remove();
    return;
  }

  if (!badge) {
    badge = document.createElement('span');
    badge.className = 'uucck-mobile-tab-bar__badge';
    badge.setAttribute('data-uucck-cart-badge', '');
    icon.appendChild(badge);
  }

  badge.textContent = itemCount > 99 ? '99+' : String(itemCount);

  try {
    sessionStorage.setItem(
      'uucck-mobile-cart-count',
      JSON.stringify({ value: String(itemCount), timestamp: Date.now() })
    );
  } catch (_) {
    // no-op
  }

  if (!animate || itemCount <= prev) return;

  badge.classList.remove('uucck-mobile-tab-bar__badge--pop');
  void badge.offsetWidth;
  badge.classList.add('uucck-mobile-tab-bar__badge--pop');
  window.setTimeout(() => badge?.classList.remove('uucck-mobile-tab-bar__badge--pop'), BADGE_POP_MS);

  const cartTab = icon.closest('.uucck-mobile-tab-bar__item--cart');
  if (cartTab instanceof HTMLElement) {
    cartTab.classList.remove('uucck-mobile-tab-bar__item--cart-bump');
    void cartTab.offsetWidth;
    cartTab.classList.add('uucck-mobile-tab-bar__item--cart-bump');
    window.setTimeout(() => cartTab.classList.remove('uucck-mobile-tab-bar__item--cart-bump'), CART_BUMP_MS);
  }
}

/** @param {import('@shopify/events').CartLinesUpdateEvent} event */
function onCartUpdate(event) {
  event.promise
    ?.then(({ cart, detail }) => {
      const itemCount = cart?.totalQuantity ?? detail?.itemCount;
      if (itemCount === undefined) return;
      renderMobileCartBadge(itemCount);
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') {
        console.warn('[uucck-mobile-tab-bar-cart] Event promise rejected:', error);
      }
    });
}

function syncFromSessionStorage() {
  try {
    const raw = sessionStorage.getItem('uucck-mobile-cart-count') ?? sessionStorage.getItem('cart-count');
    if (!raw) return;
    const { value, timestamp } = JSON.parse(raw);
    if (Date.now() - timestamp > 10000) return;
    const count = parseInt(value, 10);
    if (count >= 0) renderMobileCartBadge(count, { animate: false });
  } catch (_) {
    // no-op
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, onCartUpdate);
window.addEventListener('pageshow', (event) => {
  if (event.persisted) syncFromSessionStorage();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncFromSessionStorage);
} else {
  syncFromSessionStorage();
}
